<div class="container">
    <div mat-dialog-content>
        <div mat-dialog-title class="header3">Sync Power BI Report</div>
        <div>
            This report has not been synced with Maxis for Dealers. This means it cannot be seen by any dealerships.
            If you wish to expose this report to dealerships please provide a report owner and a description of the
            report.
        </div>
        <div class="info-text">
            Once the report has been synced, security can be added and modified.
        </div>
        <form [formGroup]="reportForm" autocomplete="off" novalidate (ngSubmit)="createReport(reportForm.value)"
        fxLayout="column wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
        <mat-form-field>
            <mat-label>ASMS</mat-label>
            <input matInput formControlName="asms" id="name" type="text">
            <mat-error *ngIf="hasError('asms', 'required')">ASMS is required</mat-error>
            <mat-error *ngIf="hasError('asms', 'maxlength')">You have more than 60 characters</mat-error>
        </mat-form-field>
        <mat-form-field>
                <div class="custom-error" *ngIf="addError && addError.includes('User')">User not found</div>
                <mat-label>Report Owner (gmid or email)</mat-label>
                <input matInput formControlName="reportOwner" id="name" type="text">
                <!-- <mat-hint align="end">Not more then 60 characters long.</mat-hint> -->
                <mat-error *ngIf="hasError('reportOwner', 'required')">Report Owner is required</mat-error>
                <mat-error *ngIf="hasError('reportOwner', 'maxlength')">You have more than 60 characters</mat-error>
            </mat-form-field>
            <!-- <mat-form-field>
                <mat-label>Report URL</mat-label>
                <input matInput formControlName="url" id="url" type="text">
                <mat-error *ngIf="hasError('url', 'required')">Url is required</mat-error>
            </mat-form-field> -->
            <mat-form-field>
                <mat-label>Description</mat-label>
                <textarea matInput formControlName="description" id="description" type="text"></textarea>
                <mat-hint align="end">Atleast 40 Characters</mat-hint>
                <mat-error *ngIf="hasError('description', 'required')">Description is required</mat-error>
                <mat-error *ngIf="hasError('description', 'maxlength')">Can't include more than 400 characters
                </mat-error>
                <mat-error *ngIf="hasError('description', 'minlength')">Must be atleast 40 characters</mat-error>
            </mat-form-field>
        </form>
        <section>
            <div class="info-text">
                Countries with access:
            </div>
            <mat-list>
                <mat-list-item *ngFor="let country of countries">
                    <mat-checkbox [(ngModel)]="country.hasAccess">{{country.fullName}}</mat-checkbox>
                </mat-list-item>
            </mat-list>
        </section>
    </div>
    <div class="button-container" mat-dialog-actions>
        <button mat-raised-button (click)="onNoClick()">Close</button>
        <button mat-raised-button cdkFocusInitial color="accent" [disabled]="!reportForm.valid"
            (click)="createReport(reportForm.value)">Sync and Modify Security</button>
    </div>
</div>